import { useState, useEffect, useMemo } from 'react';
import Select from "react-select";
import ApiService from '../../Core/Service/ApiService';

const isParent = (c) =>
    !c.parent_id || c.parent_id === '0' || c.parent_id === 0;

const byName = (a, b) =>
    String(a.category_name).localeCompare(String(b.category_name));

const buildOrderedOptions = (all) => {
    const parents = all.filter(isParent).sort(byName);
    const childrenByParent = {};
    all.filter((c) => !isParent(c)).forEach((c) => {
        const pid = c.parent_id;
        if (!childrenByParent[pid]) childrenByParent[pid] = [];
        childrenByParent[pid].push(c);
    });
    Object.values(childrenByParent).forEach((arr) => arr.sort(byName));

    const options = [];
    parents.forEach((p) => {
        options.push({ value: p.filter_desc, label: p.category_name });
        (childrenByParent[p.category_id] || []).forEach((c) => {
            options.push({
                value: c.filter_desc,
                label: `${p.category_name} / ${c.category_name}`,
            });
        });
    });
    return options;
};

let categoriesPromise = null;
const fetchAllCategoriesOnce = () => {
    if (!categoriesPromise) {
        categoriesPromise = ApiService.get('/categories/all')
            .then((r) => r.data.categories || [])
            .catch((err) => {
                categoriesPromise = null;
                throw err;
            });
    }
    return categoriesPromise;
};

const CategoryMultiSelect = ({ selected, onChange }) => {
    const [all, setAll] = useState([]);

    useEffect(() => {
        let alive = true;
        fetchAllCategoriesOnce().then((data) => {
            if (alive) setAll(data);
        });
        return () => { alive = false; };
    }, []);

    const options = useMemo(() => buildOrderedOptions(all), [all]);

    const value = useMemo(
        () => options.filter((o) => selected.includes(o.value)),
        [options, selected]
    );

    return (
        <Select
            isMulti
            options={options}
            value={value}
            onChange={onChange}
        />
    );
};

export default CategoryMultiSelect;
